// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3vzOe","text":"SelectPayment_text__gn5Xw","title":"SelectPayment_title__3QSgy","btn":"SelectPayment_btn__1C2yX"};